import * as Constants from "Data/Constants";
import * as HLF from "html-living-framework";

export default class PausePopup extends HLF.Popup {
    /** @override */
    public init(pSize: PIXI.Point) {
        super.init(pSize);
        this.addChild(HLF.PixiUtils.makeText("Paused", Constants.FONT_LUNA, 36, HLF.Colour.WHITE.toHex()));
    }

    /** @inheritdoc */
    protected AnimateIn(pCallback: () => void): void {
        pCallback();
    }

    /** @inheritdoc */
    protected AnimateOut(pCallback: () => void): void {
        pCallback();
    }

}
